import { Injectable } from '@angular/core';
import { UserScopedStorageService } from 'src/app/shared/services/user-scoped-storage.service';
import { AiGeneratedQueryData } from 'src/app/shared/services/ai-search/ai-search.service';
import {
  CompanyQueryRequest,
  Lexicon,
} from 'src/app/shared/models/ai-search.interface';
import { RecentDdSearch } from './due-diligence.model';

// v2: entries written before the company_request contract carry the deprecated
// isin/ceo_name shape. Retiring them beats migrating a 6-entry cache. Stored
// per-user (UserScopedStorageService); the legacy bare key is purged centrally
// at startup.
const STORAGE_KEY = 'dd_recent_searches_v2';
const MAX_RECENTS = 6;

@Injectable({ providedIn: 'root' })
export class DueDiligenceRecentsService {
  constructor(private userStorage: UserScopedStorageService) {}

  list(): RecentDdSearch[] {
    try {
      const parsed = JSON.parse(this.userStorage.getItem(STORAGE_KEY) ?? '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(
        (entry) => entry?.data?.query && typeof entry?.data?.name === 'string',
      );
    } catch {
      return [];
    }
  }

  add(
    data: AiGeneratedQueryData,
    request?: CompanyQueryRequest | null,
    lexicon?: Lexicon | null,
  ): RecentDdSearch[] {
    const entry: RecentDdSearch = {
      savedAt: Date.now(),
      data,
      ...(request ? { request } : {}),
      ...(lexicon ? { lexicon } : {}),
    };
    const rest = this.list().filter(
      (existing) =>
        existing.data.name.toLowerCase() !== data.name.toLowerCase(),
    );
    const next = [entry, ...rest].slice(0, MAX_RECENTS);
    this.userStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  }

  clear(): void {
    this.userStorage.removeItem(STORAGE_KEY);
  }
}
